import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ROLES } from '@/constants';
import { LoadingScreen } from '@/components/common/loaders/LoadingScreen';

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles: ROLES[];
  fallbackPath?: string;
}

export function RoleGuard({ children, allowedRoles, fallbackPath = '/unauthorized' }: RoleGuardProps) {
  const { user, isLoading, isAuthenticated } = useAuth();

  if (isLoading) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!user || !allowedRoles.includes(user.role as ROLES)) {
    return <Navigate to={fallbackPath} replace />;
  }
  return <>{children}</>;
}
